module.exports = __webpack_public_path__ + "img/sd.3aa7c54a.svg";